// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ClientID from "../Ouroboros.Models.Brands.ClientID/index.js";
import * as Ouroboros_Models_Brands_ClientName from "../Ouroboros.Models.Brands.ClientName/index.js";
import * as Ouroboros_Models_Brands_DocumentUploadFileName from "../Ouroboros.Models.Brands.DocumentUploadFileName/index.js";
import * as Ouroboros_Models_Brands_ErrorInfoText from "../Ouroboros.Models.Brands.ErrorInfoText/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_HttpStatusCode from "../Ouroboros.Models.Brands.HttpStatusCode/index.js";
import * as Ouroboros_Models_Brands_ProjectID from "../Ouroboros.Models.Brands.ProjectID/index.js";
import * as Ouroboros_Models_Brands_ProjectName from "../Ouroboros.Models.Brands.ProjectName/index.js";
import * as Ouroboros_Models_Brands_StorageURI from "../Ouroboros.Models.Brands.StorageURI/index.js";
import * as Ouroboros_Models_Brands_UploadURL from "../Ouroboros.Models.Brands.UploadURL/index.js";
import * as Ouroboros_Models_Clients_ClientRequestBuilders from "../Ouroboros.Models.Clients.ClientRequestBuilders/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var wrapMessage = Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText;
var wrapInfo = Ouroboros_Models_Brands_ErrorInfoText.makeErrorInfoText;
var runUploadDocumentClient = function (v) {
    return function (payload) {
        return v(payload);
    };
};
var runOpenDocumentController = function (v) {
    return function (payload) {
        return v(payload);
    };
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runDownloadDocumentController = function (v) {
    return function (payload) {
        return v(payload);
    };
};
var readStatusCode = function (statusCode) {
    if (statusCode instanceof Data_Maybe.Nothing) {
        return Data_Maybe.Nothing.value;
    };
    if (statusCode instanceof Data_Maybe.Just) {
        return Data_Int.fromNumber(Ouroboros_Models_Brands_HttpStatusCode.unwrap(statusCode.value0));
    };
    throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.Clients (line 606, column 3 - line 608, column 63): " + [ statusCode.constructor.name ]);
};
var readState = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var handleNavigateProject = function (kernel) {
    return function (projectId) {
        var activeClientId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(kernel.activeClientId));
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
        })(function (clientId) {
            return runNavigate(kernel.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(kernel.clientsRouteWithProject)({
                clientId: clientId,
                projectId: projectId
            }));
        })(activeClientId);
    };
};
var onNavigateProject = function (kernel) {
    return handleNavigateProject(kernel);
};
var handleNavigateClient = function (kernel) {
    return function (clientId) {
        return runNavigate(kernel.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(kernel.clientsRouteWithClient)(clientId));
    };
};
var onNavigateClient = function (kernel) {
    return handleNavigateClient(kernel);
};
var handleLoadProjectsSuccess = function (kernel) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.projects))(response.items), runLoadingAction(kernel.loading.setSuccess) ]));
    };
};
var handleLoadDocumentsSuccess = function (kernel) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.documents))(response.items), runLoadingAction(kernel.loading.setSuccess) ]));
    };
};
var handleLoadClientsSuccess = function (kernel) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.clients))(response.items), runLoadingAction(kernel.loading.setSuccess) ]));
    };
};
var handleBackToProjects = function (kernel) {
    var activeClientId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(kernel.activeClientId));
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
    })(function (clientId) {
        return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(kernel.activeProjectId))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.documents))([  ]), runNavigate(kernel.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(kernel.clientsRouteWithClient)(clientId)) ]);
    })(activeClientId);
};
var onBackToProjects = function (kernel) {
    return function (v) {
        return handleBackToProjects(kernel);
    };
};
var handleBackToClients = function (kernel) {
    return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(kernel.activeClientId))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(kernel.activeProjectId))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.projects))([  ]), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.documents))([  ]), runNavigate(kernel.navigate)(kernel.clientsRoute) ]);
};
var onBackToClients = function (kernel) {
    return function (v) {
        return handleBackToClients(kernel);
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/clients_controller.md";
var deriveClientErrorDetails = function (errorValue) {
    return function (fallback) {
        var $78 = errorValue.type === "ServerError";
        if ($78) {
            var v = readStatusCode(errorValue.statusCode);
            if (v instanceof Data_Maybe.Just) {
                return Ouroboros_Services_Clients_Interop_Option.some(fallback + (" (status " + (show(v.value0) + ")")));
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Models_Brands_ErrorMessageText.unwrap(errorValue.message));
            };
            throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.Clients (line 596, column 5 - line 598, column 74): " + [ v.constructor.name ]);
        };
        var $81 = Ouroboros_Models_Brands_ErrorMessageText.unwrap(errorValue.message) === "";
        if ($81) {
            return Ouroboros_Services_Clients_Interop_Option.some(fallback);
        };
        return Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Models_Brands_ErrorMessageText.unwrap(errorValue.message));
    };
};
var buildUploadTasks = function (upload) {
    return function (files) {
        return function (uploads) {
            var lookup = function (fileName) {
                return Data_Array.find(function (file) {
                    return Ouroboros_Models_Brands_DocumentUploadFileName.unwrap(file.fileName) === fileName;
                })(files);
            };
            return map(function (item) {
                var v = lookup(Ouroboros_Models_Brands_DocumentUploadFileName.unwrap(item.document.filename));
                if (v instanceof Data_Maybe.Nothing) {
                    return Ouroboros_Services_Clients_Interop_TaskEither.left("Missing file for " + Ouroboros_Models_Brands_DocumentUploadFileName.unwrap(item.document.filename));
                };
                if (v instanceof Data_Maybe.Just) {
                    return runUploadDocumentClient(upload)({
                        uploadUrl: Ouroboros_Models_Brands_UploadURL.unwrap(item.upload_url),
                        fileName: v.value0.fileName,
                        file: v.value0.file
                    });
                };
                throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.Clients (line 627, column 9 - line 635, column 16): " + [ v.constructor.name ]);
            })(uploads);
        };
    };
};
var buildPresignRequest = function (files) {
    return Ouroboros_Models_Clients_ClientRequestBuilders.buildPresignProjectDocumentsRequest(map(function (file) {
        return {
            filename: Ouroboros_Models_Brands_DocumentUploadFileName.unwrap(file.fileName),
            file_size: file.fileSize
        };
    })(files));
};
var buildLoadingError = function (message) {
    return function (info) {
        return {
            message: wrapMessage(message),
            info: Ouroboros_Services_Clients_Interop_Option.map(wrapInfo)(info)
        };
    };
};
var handleDownloadDocument = function (kernel) {
    return function (doc) {
        var $84 = Ouroboros_Models_Brands_StorageURI.unwrap(doc.storage_uri) === "";
        if ($84) {
            return runLoadingAction(kernel.loading.setError(buildLoadingError("Download document")(Ouroboros_Services_Clients_Interop_Option.some("No document URL is available."))));
        };
        return runDownloadDocumentController(kernel.downloadDocumentController)({
            url: Ouroboros_Models_Brands_StorageURI.unwrap(doc.storage_uri),
            filename: Ouroboros_Models_Brands_DocumentUploadFileName.unwrap(doc.filename)
        });
    };
};
var onDownloadDocument = function (kernel) {
    return handleDownloadDocument(kernel);
};
var handleGenericError = function (kernel) {
    return function (fallback) {
        return function (errorValue) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(buildLoadingError(fallback)(deriveClientErrorDetails(errorValue)(fallback)))));
        };
    };
};
var handleLoadClientsError = function (kernel) {
    return function (errorValue) {
        if (errorValue.type === "ServerError") {
            var v = readStatusCode(errorValue.statusCode);
            if (v instanceof Data_Maybe.Just && v.value0 === 404) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.clients))([  ]), runLoadingAction(kernel.loading.setSuccess) ]));
            };
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(buildLoadingError("Unable to load clients.")(deriveClientErrorDetails(errorValue)("Unable to load clients.")))));
        };
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(buildLoadingError("Unable to load clients.")(deriveClientErrorDetails(errorValue)("Unable to load clients.")))));
    };
};
var refreshClientsTask = function (kernel) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLoadClientsError(kernel))(handleLoadClientsSuccess(kernel))(kernel.clientProjectClient.listClients);
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setLoading)));
};
var buildOnInit = function (kernel) {
    return Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Programs_Capabilities.runTaskRunner(kernel.taskRunner)(refreshClientsTask(kernel)));
};
var handleCreateClient = function (input) {
    return function (name) {
        var trimmed = Data_String_Common.trim(name);
        var $88 = trimmed === "";
        if ($88) {
            return runLoadingAction(input.kernel.loading.setError(buildLoadingError("Client name is required.")(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit))));
        };
        return Ouroboros_Programs_Capabilities.runTaskRunner(input.kernel.taskRunner)(Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleGenericError(input.kernel)("Unable to create client."))(function (v1) {
                return Ouroboros_Services_Clients_Interop_Task.chain(function (v2) {
                    return refreshClientsTask(input.kernel);
                })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.newClientName))("")));
            })(input.kernel.clientProjectClient.createClient({
                name: Ouroboros_Models_Brands_ClientName.makeClientName(trimmed)
            }));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(input.kernel.loading.setLoading))));
    };
};
var onCreateClient = function (input) {
    return handleCreateClient(input);
};
var handleLoadDocumentsError = function (kernel) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(buildLoadingError("Unable to load documents.")(deriveClientErrorDetails(errorValue)("Unable to load documents.")))));
    };
};
var refreshDocumentsTask = function (kernel) {
    return function (projectId) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLoadDocumentsError(kernel))(handleLoadDocumentsSuccess(kernel))(kernel.clientProjectClient.listProjectDocuments(projectId));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setLoading)));
    };
};
var handleDeleteDocument = function (input) {
    return function (documentId) {
        var activeProjectId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.activeProjectId));
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
        })(function (projectId) {
            return Ouroboros_Programs_Capabilities.runTaskRunner(input.kernel.taskRunner)(Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleGenericError(input.kernel)("Unable to delete document."))(function (v1) {
                    return refreshDocumentsTask(input.kernel)(projectId);
                })(input.kernel.clientProjectClient.deleteProjectDocument(projectId)(documentId));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(input.kernel.loading.setLoading))));
        })(activeProjectId);
    };
};
var onDeleteDocument = function (input) {
    return handleDeleteDocument(input);
};
var handleRouteProjectChange = function (input) {
    return function (routeProjectId) {
        var projects = readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.projects));
        var matchesProject = Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return false;
        })(function (projectId) {
            return Data_Array.any(function (project) {
                return Ouroboros_Models_Brands_ProjectID.unwrap(project.id) === projectId;
            })(projects);
        })(routeProjectId);
        var activeProjectId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.activeProjectId));
        var isSame = Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v1) {
                return true;
            })(function (v1) {
                return false;
            })(activeProjectId);
        })(function (projectId) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return false;
            })(function (value) {
                return value === projectId;
            })(activeProjectId);
        })(routeProjectId);
        var $89 = Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return true;
        })(function (v) {
            return false;
        })(routeProjectId);
        if ($89) {
            return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(input.kernel.activeProjectId))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.documents))([  ]) ]);
        };
        var $90 = matchesProject && !isSame;
        if ($90) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
            })(function (projectId) {
                return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(input.kernel.activeProjectId))(projectId), Ouroboros_Programs_Capabilities.runTaskRunner(input.kernel.taskRunner)(refreshDocumentsTask(input.kernel)(projectId)) ]);
            })(routeProjectId);
        };
        return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
    };
};
var onRouteProjectChange = function (input) {
    return handleRouteProjectChange(input);
};
var handleLoadProjectsError = function (kernel) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(buildLoadingError("Unable to load projects.")(deriveClientErrorDetails(errorValue)("Unable to load projects.")))));
    };
};
var refreshProjectsTask = function (kernel) {
    return function (clientId) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLoadProjectsError(kernel))(handleLoadProjectsSuccess(kernel))(kernel.clientProjectClient.listProjects(clientId));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setLoading)));
    };
};
var handleCreateProject = function (input) {
    return function (title) {
        var trimmed = Data_String_Common.trim(title);
        var activeClientId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.activeClientId));
        var $91 = trimmed === "";
        if ($91) {
            return runLoadingAction(input.kernel.loading.setError(buildLoadingError("Project title is required.")(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit))));
        };
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return runLoadingAction(input.kernel.loading.setError(buildLoadingError("Select a client first.")(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit))));
        })(function (clientId) {
            return Ouroboros_Programs_Capabilities.runTaskRunner(input.kernel.taskRunner)(Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleGenericError(input.kernel)("Unable to create project."))(function (v1) {
                    return Ouroboros_Services_Clients_Interop_Task.chain(function (v2) {
                        return refreshProjectsTask(input.kernel)(clientId);
                    })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.newProjectTitle))("")));
                })(input.kernel.clientProjectClient.createProject(clientId)({
                    name: Ouroboros_Models_Brands_ProjectName.makeProjectName(trimmed)
                }));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(input.kernel.loading.setLoading))));
        })(activeClientId);
    };
};
var onCreateProject = function (input) {
    return handleCreateProject(input);
};
var handleDeleteProject = function (input) {
    return function (projectId) {
        var activeProjectId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.activeProjectId));
        var clearActive = (function () {
            var $92 = Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return false;
            })(function (value) {
                return value === projectId;
            })(activeProjectId);
            if ($92) {
                return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(input.kernel.activeProjectId))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.documents))([  ]) ]);
            };
            return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
        })();
        var activeClientId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.activeClientId));
        var refreshTask = Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.pure(Ouroboros_Models_Core_Ok.ok);
        })(function (clientId) {
            return refreshProjectsTask(input.kernel)(clientId);
        })(activeClientId);
        return Ouroboros_Programs_Capabilities.runTaskRunner(input.kernel.taskRunner)(Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleGenericError(input.kernel)("Unable to delete project."))(function (v1) {
                return Ouroboros_Services_Clients_Interop_Task.chain(function (v2) {
                    return Ouroboros_Services_Clients_Interop_Task.fromIO(clearActive);
                })(refreshTask);
            })(input.kernel.clientProjectClient.deleteProject(projectId));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(input.kernel.loading.setLoading))));
    };
};
var onDeleteProject = function (input) {
    return handleDeleteProject(input);
};
var handleRouteClientChange = function (input) {
    return function (routeClientId) {
        var clients = readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.clients));
        var matchesClient = Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return false;
        })(function (clientId) {
            return Data_Array.any(function (client) {
                return Ouroboros_Models_Brands_ClientID.unwrap(client.id) === clientId;
            })(clients);
        })(routeClientId);
        var activeClientId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.activeClientId));
        var isSame = Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v1) {
                return true;
            })(function (v1) {
                return false;
            })(activeClientId);
        })(function (clientId) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return false;
            })(function (value) {
                return value === clientId;
            })(activeClientId);
        })(routeClientId);
        var $93 = Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return true;
        })(function (v) {
            return false;
        })(routeClientId);
        if ($93) {
            return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(input.kernel.activeClientId))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(input.kernel.activeProjectId))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.projects))([  ]), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.documents))([  ]) ]);
        };
        var $94 = matchesClient && !isSame;
        if ($94) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
            })(function (clientId) {
                return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(input.kernel.activeClientId))(clientId), Ouroboros_Programs_Capabilities.runTaskRunner(input.kernel.taskRunner)(refreshProjectsTask(input.kernel)(clientId)) ]);
            })(routeClientId);
        };
        return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
    };
};
var onRouteClientChange = function (input) {
    return handleRouteClientChange(input);
};
var refreshProjectsAfterAction = function (kernel) {
    var activeClientId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(kernel.activeClientId));
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.pure(Ouroboros_Models_Core_Ok.ok);
    })(function (clientId) {
        return refreshProjectsTask(kernel)(clientId);
    })(activeClientId);
};
var handleRenameProject = function (input) {
    return function (payload) {
        var trimmed = Data_String_Common.trim(payload.title);
        var $95 = trimmed === "";
        if ($95) {
            return runLoadingAction(input.kernel.loading.setError(buildLoadingError("Project title is required.")(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit))));
        };
        return Ouroboros_Programs_Capabilities.runTaskRunner(input.kernel.taskRunner)(Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleGenericError(input.kernel)("Unable to rename project."))(function (v1) {
                return refreshProjectsAfterAction(input.kernel);
            })(input.kernel.clientProjectClient.updateProject(payload.projectId)({
                name: Ouroboros_Models_Brands_ProjectName.makeProjectName(trimmed)
            }));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(input.kernel.loading.setLoading))));
    };
};
var onRenameProject = function (input) {
    return handleRenameProject(input);
};
var handleUploadPresignSuccess = function (kernel) {
    return function (projectId) {
        return function (files) {
            return function (response) {
                var uploadTasks = buildUploadTasks(kernel.uploadDocumentClient)(files)(response.items);
                return Ouroboros_Services_Clients_Interop_TaskEither.fold(function (message) {
                    return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(buildLoadingError("Upload failed.")(Ouroboros_Services_Clients_Interop_Option.some(message)))));
                })(function (v) {
                    return Ouroboros_Services_Clients_Interop_Task.chain(function (v1) {
                        return refreshDocumentsTask(kernel)(projectId);
                    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setSuccess)));
                })(Ouroboros_Services_Clients_Interop_TaskEither.sequenceOk(uploadTasks));
            };
        };
    };
};
var uploadDocumentsSequence = function (kernel) {
    return function (clientId) {
        return function (projectId) {
            return function (files) {
                return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                    return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleGenericError(kernel)("Unable to request upload URLs."))(handleUploadPresignSuccess(kernel)(projectId)(files))(kernel.clientProjectClient.presignProjectDocuments(clientId)(projectId)(buildPresignRequest(files)));
                })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok)));
            };
        };
    };
};
var uploadDocumentsTask = function (kernel) {
    return function (clientId) {
        return function (projectId) {
            return function (files) {
                return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                    return Ouroboros_Services_Clients_Interop_Task.chain(function (v1) {
                        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.isUploading))(false));
                    })(uploadDocumentsSequence(kernel)(clientId)(projectId)(files));
                })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ runLoadingAction(kernel.loading.setLoading), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.isUploading))(true) ])));
            };
        };
    };
};
var handleUploadDocuments = function (input) {
    return function (payload) {
        var activeProjectId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.activeProjectId));
        var activeClientId = readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.activeClientId));
        var $96 = !input.directUploadEnabled;
        if ($96) {
            return runLoadingAction(input.kernel.loading.setError(buildLoadingError("Upload disabled")(Ouroboros_Services_Clients_Interop_Option.some("Direct S3 uploads are disabled in this environment."))));
        };
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
        })(function (clientId) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
            })(function (projectId) {
                var $97 = Data_Array.length(payload.files) === 0;
                if ($97) {
                    return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
                };
                return Ouroboros_Programs_Capabilities.runTaskRunner(input.kernel.taskRunner)(uploadDocumentsTask(input.kernel)(clientId)(projectId)(payload.files));
            })(activeProjectId);
        })(activeClientId);
    };
};
var onUploadDocuments = function (input) {
    return handleUploadDocuments(input);
};
var handleViewDocument = function (kernel) {
    return function (doc) {
        var $98 = Ouroboros_Models_Brands_StorageURI.unwrap(doc.storage_uri) === "";
        if ($98) {
            return runLoadingAction(kernel.loading.setError(buildLoadingError("View document")(Ouroboros_Services_Clients_Interop_Option.some("No document URL is available."))));
        };
        return runOpenDocumentController(kernel.openDocumentController)(Ouroboros_Models_Brands_StorageURI.unwrap(doc.storage_uri));
    };
};
var onViewDocument = function (kernel) {
    return handleViewDocument(kernel);
};
export {
    buildOnInit,
    onCreateClient,
    onCreateProject,
    onRenameProject,
    onDeleteProject,
    onDeleteDocument,
    onUploadDocuments,
    onViewDocument,
    onDownloadDocument,
    onBackToClients,
    onBackToProjects,
    onNavigateClient,
    onNavigateProject,
    onRouteClientChange,
    onRouteProjectChange,
    documentationPath
};
//# sourceMappingURL=index.js.map
